import React from "react";
import {
  Box,
  Container,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AppDialogHalfScreen from "./AppDialogHalfScreen";
import Cross from "../assets/logo/cross.svg";
import { logEvent } from "../store/api";
import { EVENTS, ACTIVITY_DETAIL } from "../utils/events";
import { useLocation } from "react-router-dom";

export default function AppNotificationPopup({
  show,
  onChangeShow,
  notification,
}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const location = useLocation();
  
  const handleClose = () => {
    logEvent({
      current: EVENTS['NOTIFICATION']['NOTIFICATION_DISMISS'],
      activity: ACTIVITY_DETAIL['NOTIFICATION']['NOTIFICATION_DISMISS'],
      meta: {
        data: {
          pathname: location.pathname,
          notificationSubject: notification?.subject
        }
      }
    });
    onChangeShow(false);
  };

  if (!notification || !notification.subject || !notification.description) {
    return null;
  }

  // The description field contains HTML content to display
  const htmlContent = notification.description;

  return (
    <AppDialogHalfScreen 
      show={show} 
      onChangeShow={onChangeShow}
    >
      <Container 
        maxWidth="md" 
        disableGutters
        sx={{ 
          padding: 1,
          width: "100%"
        }}
      >
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          marginTop={1}
        >
          <Box flex={1}>
            {/* Extract plain text title from HTML for the header, or use a default title */}
            <Typography variant="h6" color={"#F8FAFF"}>
                {notification.subject}
            </Typography>
          </Box>
          <IconButton onClick={handleClose} aria-label="close notification">
            <Cross
              aria-label="close notification"
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
              }}
            />
          </IconButton>
        </Box>

        <Box
          sx={{
            color: "#F8FAFF",
            fontSize: "14px",
            marginTop: 1,
            ...(isMobile && {
              maxHeight: "calc(100vh - 200px)",
              overflowY: "auto",
              paddingRight: 1,
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(255, 255, 255, 0.3)",
                borderRadius: "10px",
                "&:hover": {
                  background: "rgba(255, 255, 255, 0.5)",
                },
              },
            }),
            "& p": {
              color: "#F8FAFF",
              marginBottom: 1,
              fontSize: 16,
            },
            "& a": {
              color: "#0088F5",
            },
            "& h1, & h2, & h3, & h4, & h5, & h6": {
              color: "#F8FAFF",
            },
          }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </Container>
    </AppDialogHalfScreen>
  );
}

